import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AdminService } from '../../services/admin.service';

@Component({
    selector: 'app-warnings-dialog',
    templateUrl: './warnings-dialog.component.html',
    styleUrl: './warnings-dialog.component.scss',
    standalone: false
})
export class WarningsDialogComponent implements OnInit {
  loading = false;

  warnings = [];

  warningsTranslations = {
    no_categories: { text: 'No hay categorias creadas.', link: '/admin/main/products' },
    no_main_category: { text: 'No hay una (y solo una) categoria principal.', link: '/admin/main/products' },
    more_than_one_main_category: { text: 'Hay más de una categoria principal.', link: '/admin/main/products' },
    no_products_in_category: {
      text: 'Las siguientes categorías no tienen ningún producto asociados:',
      link: '/admin/main/products',
    },
    missing_order_statuses: {
      text: `Faltan los siguientes tipos de estados para ${this.adminService.getText('order_plural')}:`,
      link: '/admin/main/orders',
    },
    missing_budget_statuses: {
      text: `Faltan los siguientes tipos de estados para ${this.adminService.getText('budget_plural')}:`,
      link: '/admin/main/budgets',
    },
    missing_inventory_action_statuses: {
      text: `Faltan los siguientes tipos de estados para
        ${this.adminService.getText('inventory_action_for_consume_plural')}:`,
      link: '/admin/main/inventory',
    },
    missing_crm_for_booking_statuses: {
      text: `Faltan estados de tipo inicial, fallido, completado y final para
     ${this.adminService.getText('crm_for_booking_plural')}.`,
      link: '/admin/main/crms/booking',
    },
    missing_order_status_transitions: {
      text: `Los siguientes estados de ${this.adminService.getText('order_plural')}
      no son parte de ninguna transición:`,
      link: '/admin/main/orders',
    },
    missing_budget_status_transitions: {
      text: `Los siguientes estados de ${this.adminService.getText('budget_plural')}
      no son parte de ninguna transición:`,
      link: '/admin/main/budgets',
    },
    missing_budget_works: {
      text: `Los siguientes estados de ${this.adminService.getText('budget_plural')} no tienen un trabajo asociado:`,
      link: '/admin/main/budgets',
    },
    missing_order_works: {
      text: `Los siguientes estados de ${this.adminService.getText('order_plural')} no tienen un trabajo asociado:`,
      link: '/admin/main/orders',
    },
    works_with_same_status_id: {
      text: 'No debe existir dos Trabajos que puedan cambiar estados apuntando a un mismo estado.',
      link: null,
    },
    missing_mailing_preferences: {
      text: 'Falta configurar el mailing.',
      link: '/admin/main/company',
    },
    missing_crm_for_booking_preferences: {
      text: `Falta configurar el ${this.adminService.getText('crm/booking')}`,
      link: '/admin/main/crms/booking',
    },
    no_tags: {
      text: 'No hay etiquetas creadas.',
      link: '/admin/main/budgets',
    },
    missing_tags_categories: {
      text: 'Las siguientes categorías no son parte de ninguna etiqueta:',
      link: '/admin/main/budgets',
    },
    no_locales: {
      text: `No hay ${this.adminService.getText('location_plural')} creados.`,
      link: '/admin/main/locations',
    },
    missing_warehouse_in_locations: {
      text: `Todos los ${this.adminService.getText('location_plural')}
     deben tener un almacen asociado.`,
      link: '/admin/main/locations',
    },
    missing_location_in_users: {
      text: `Los siguientes usuarios no tienen ningún
      ${this.adminService.getText('location')} asociado:`,
      link: '/admin/main/users',
    },
    no_requirements: { text: 'No hay requerimientos creados.', link: '/admin/main/booking' },
    no_users: { text: 'No hay usuarios creados.', link: '/admin/main/users' },
    no_roles: { text: 'No hay roles creados.', link: '/admin/main/roles' },
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private adminService: AdminService,
    private matDialogRef: MatDialogRef<WarningsDialogComponent>,
    private cdr: ChangeDetectorRef,
  ) {
    this.warnings = this.data.warnings;
  }

  ngOnInit(): void {
    this.matDialogRef.disableClose = true;
    this.matDialogRef.backdropClick().subscribe(() => {
      this.matDialogRef.close(this.warnings);
    });
  }

  onReload() {
    this.getWarnings();
  }

  getWarnings() {
    this.cdr.markForCheck();
    this.loading = true;

    this.adminService.configuration_warnings().subscribe((response) => {
      this.cdr.markForCheck();
      this.loading = false;
      this.warnings = response.body;
    });
  }
}
